<template>
  <div class="max-w-xl mx-auto mt-10">
    <div class="rounded-md bg-yellow-50 p-4 mb-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <!-- Heroicon name: solid/information-circle -->
          <svg
            class="h-5 w-5 text-yellow-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-sm text-yellow-700">
            If the customer is not on whatsapp you will get this error. If you
            get the error for all the checkouts / orders please follow below
            solutions
          </p>
        </div>
      </div>
    </div>
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Phone number invalid error
        </h3>
        <div class="mt-2 max-w-xl text-sm text-gray-500">
          <div>
            Recently WhatsApp has made a few changes to their WhatsApp web
            platform. It's not allowing to send messages to customers who are
            not part of their contacts.

            <br />
            <br />
            <h1 class="text-sm font-medium leading-6 text-gray-900">
              To Use Whatsapp web
            </h1>
            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 1: Goto this link on Chrome and click clear data 
            </span>
            <div class="mt-3 text-sm">
              <a
                class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
                href="chrome://settings/content/siteDetails?site=https://web.whatsapp.com/"
                @click="openSettings"
                target="_blank"
                >chrome://settings/content/siteDetails?site=https://web.whatsapp.com/
              </a>
            </div>
            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 2: Once you clear the data open web.whatsapp.com and link
              your devices,
            </span>
            <div class="mt-3 text-sm">
              <a
                href="https://web.whatsapp.com"
                target="_blank"
                class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
              >
                Open Whatsapp web
                <span aria-hidden="true"> &rarr;</span>
              </a>
            </div>
            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 3: Now change you sending preferences
            </span>
            <div class="mt-3 text-sm">
              <a
                @click="$router.push({ name: 'Preference' })"
                class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
              >
                Open preferences
                <span aria-hidden="true"> &rarr;</span>
              </a>
            </div>
            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 4: Start sending messages
            </span>

            <br />
            <br />
            <div>(or)</div>
            <br />
            <br />
            <h1 class="text-sm font-medium leading-6 text-gray-900">
              To Use Whatsapp Desktop App
            </h1>
            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 1: Install the whatsapp desktop app</span
            >
            <br />

            <div class="mt-3 text-sm">
              <a
                class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
                href="https://whatsapp-desktop.en.uptodown.com/windows/download/79075839"
                target="_blank"
                >Whatsapp Desktop For Windows</a
              >

              <a
                class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer ml-4"
                href="https://whatsapp-desktop.en.uptodown.com/mac/download/79083743"
                target="_blank"
                >Whatsapp Desktop For Mac</a
              >
              <br />
            </div>

            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 2: Once you installed the app, Please configure it
              here</span
            >
          </div>
        </div>
        <div class="mt-3 text-sm">
          <a
            @click="$router.push({ name: 'Preference' })"
            class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
          >
            Open preferences
            <span aria-hidden="true"> &rarr;</span>
          </a>
        </div>
        <div class="mt-4 max-w-xl text-sm text-gray-500">
          <p>
            If you are still facing the error for all the checkouts / orders
            then please contact us
          </p>
        </div>
        <div class="mt-3 text-sm">
          <a
            class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
            @click="contact"
          >
            Contact us
            <span aria-hidden="true"> &rarr;</span>
          </a>
        </div>
      </div>
    </div>
    <div class="bg-white shadow sm:rounded-lg my-10">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Chosen template not showing in whatsapp desktop app
        </h3>
        <div class="mt-2 max-w-xl text-sm text-gray-500">
          <div>
            On the newer version of the WhatsApp desktop app for windows, there
            is a problem where the selected template is not populated while
            sending the automated message. To fix this please uninstall the
            current app and install it from the link below

            <br />
            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 1: Uninstall the current whatsapp desktop app</span
            >
            <br />
            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 2: Install the whatsapp desktop app</span
            >
            <br />

            <div class="mt-3 text-sm">
              <a
                class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
                href="https://whatsapp-desktop.en.uptodown.com/windows/download/79075839"
                target="_blank"
                >Whatsapp Desktop For Windows</a
              >

              <a
                class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer ml-4"
                href="https://whatsapp-desktop.en.uptodown.com/mac/download/79083743"
                target="_blank"
                >Whatsapp Desktop For Mac</a
              >
              <br />
            </div>

            <br />
            <span class="text-sm font-medium leading-6 text-gray-900"
              >Step 3: Once you installed the app, Please configure it
              here</span
            >
          </div>
        </div>
        <div class="mt-3 text-sm">
          <a
            @click="$router.push({ name: 'Preference' })"
            class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
          >
            Open preferences
            <span aria-hidden="true"> &rarr;</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    contact() {
      $crisp.push(["do", "chat:open"]); // eslint-disable-line

      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:show",
        [
          "text",
          `Hi!, Have you installed Whatsapp Desktop App?
        Have you changed the preferences in our app?`
        ]
      ]);
      // // eslint-disable-next-line
      // $crisp.push([
      //   "do",
      //   "message:send",
      //   [
      //     "text",
      //     `Hi, am getting the phone number shared via URL is an invalid error. `
      //   ]
      // ]);
    },
    openSettings() {
      window.open(
        "chrome://settings/content/siteDetails?site=https://web.whatsapp.com/",
        "_blank"
      );
    }
  }
};
</script>

<style></style>
